import React, { FC } from 'react';
import classes from './ScanIcon.module.css';

type ScanIconProps = {
  label: string
  iconHeight?: number
  iconHidden?: boolean
}
export const ScanIcon: FC<ScanIconProps> = ({ label, iconHidden, iconHeight }) => {
  return (
      <div className={classes.root}>
        <div className={`${classes.icon} ${iconHidden ? classes.hidden : ''} `} style={iconHeight ? { height: iconHeight } : undefined}></div>
        <div className={classes.text}>{label}</div>
      </div>
  );
};